function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{display:none;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;}\n\t.st3{fill:url(#SVGID_1_);}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M1174.8,624.7c-14.4,3.3-52.3,5.2-52.3,5.2l-4.8,15c0,0,18.9-1.6,32.7-0.2c0,0,4.5-0.5,5,5.1 c0.2,5.2-0.4,10.8-0.4,10.8s-0.3,3.4-5.1,4.2c-5.2,0.9-40.8,2.2-40.8,2.2l-5.8,19.5c0,0-2.1,4.5,2.7,3.2 c4.5-1.2,41.8-8.2,46.7-7.2c5.2,1.3,11,8.2,9.3,14.6c-2,7.8-39.2,31.6-61.9,29.9c0,0-11.9,0.8-22-15.3 c-9.4-15.3,3.6-44.4,3.6-44.4s-5.9-13.6-1.6-18.1c0,0,2.6-2.3,10-2.9l9.1-18.9c0,0-10.4,0.7-16.6-6.9 c-5.8-7.3-6.2-10.6-1.8-12.6c4.7-2.3,48-10.2,77.8-9.2c0,0,10.4-1,19.3,17C1177.8,615.7,1182.2,623,1174.8,624.7L1174.8,624.7z  M1062.7,697.3c-3.8,9-13.9,18.6-26.4,12.6c-12.4-6-32.1-46.3-32.1-46.3s-7.5-15-8.9-14.7c0,0-1.6-2.9-2.6,13.5 c-1,16.4,0.2,48.3-6.3,53.3c-6.2,5-13.7,3-17.6-2.9c-3.5-5.8-5-19.6-3.1-43.8c2.3-24.2,7.9-50,15.1-58.1c7.2-8,13-2.2,15.2-0.1 c0,0,9.6,8.7,25.5,34.3l2.8,4.7c0,0,14.4,24.2,15.9,24.1c0,0,1.2,1.1,2.2,0.3c1.5-0.4,0.9-8.2,0.9-8.2s-3-26.3-16.1-70.9 c0,0-2-5.6-0.6-10.8c1.3-5.3,6.6-2.8,6.6-2.8s20.4,10.2,30.2,43.4C1073.1,658.4,1066.5,688.3,1062.7,697.3L1062.7,697.3z  M962.5,612c-1.7,3.4-2.7,8.3-11.3,9.6c0,0-82.3,5.6-86.2,11.4c0,0-2.9,3.4,1.6,4.4c4.5,0.9,23.1,3.4,32.1,3.9 c9.6,0.1,42,0.4,53.6,14.9c0,0,6.9,6.9,6.6,22.5c-0.3,16-3.1,21.6-9.3,27.4c-6.5,5.4-62.3,30.4-98.3-8c0,0-16.6-18.5,5.7-32.5 c0,0,16.1-9.7,57,1.7c0,0,12.4,4.5,11.8,9c-0.7,4.8-10.2,9.9-24,9.6c-13.4-0.4-23.2-6.8-21.3-5.8c1.8,0.7-14.4-7.8-19.4-2 c-5,5.3-3.8,8.6,1.1,11.9c12.5,7.1,60.8,4.6,75.2-11.4c0,0,5.7-6.5-3-11.8c-8.7-5-33.6-8-43.3-8.5c-9.3-0.5-43.9,0.1-48.9-9.1 c0,0-5-6.2,0.5-23.8c5.8-18.4,46.1-25.5,63.5-27.1c0,0,47.9-1.7,56.7,8.1C962.8,606.4,964,608.7,962.5,612L962.5,612z  M826.5,719.9c-5.8,4.3-18.1,2.4-21.6-2.4c-3.5-4.3-4.7-21.4-4-48.2c0.7-27.1,1.3-60.7,7.1-66c6.2-5.4,10-0.7,12.4,3 c2.6,3.6,5.7,7.6,6.4,16.1c0.6,8.5,2.6,53.1,2.6,53.1S832,715.7,826.5,719.9L826.5,719.9z M839,576.1 c-16.9,5.6-28.5,3.7-38.3-0.5c-4.3,7.5-6.8,9.8-10.1,10.3c-4.8,0.5-9.1-7.2-9.9-9.7c-0.8-1.9-3.1-5.1-0.3-12.7 c-9.6-8.6-10.3-20.2-8.7-28c2.4-9,18.6-43.2,67.9-47.2c0,0,24.1-1.8,28.2,11.1h0.7c0,0,23.4,0.1,22.9,20.9 C891.1,541.2,865.4,567.2,839,576.1L839,576.1z M793,529.8c-5,8-5.2,12.8-2.9,16.1c5.7-8.7,16.1-22.4,31.4-32.8 C809.7,514.1,799.8,519.2,793,529.8L793,529.8z M861.1,516.4c-15.5,2.3-39.5,23.1-50.9,40.1c17.5,3.2,48.4,2,62.1-25.9 C872.2,530.6,878.8,513.3,861.1,516.4L861.1,516.4z M1281.9,677.5c-9.3,16.2-35.4,50-70.2,42.1c-11.5,27.9-21.1,56-26.6,98.2 c0,0-1.2,8.2-8,5.3c-6.7-2.4-17.9-13.6-20.1-29.1c-2.4-20.4,6.7-54.9,25.2-94.4c-5.4-8.8-9.1-21.4-5.9-39.3 c0,0,4.7-33.2,38-63.2c0,0,4-3.5,6.3-2.4c2.6,1.1,1.4,11.9-0.7,17.1c-2.1,5.2-17,31-17,31s-9.3,17.4-6.7,31.1 c17.5-26.9,57.3-81.2,82-64.1c8.3,5.9,12.1,18.8,12.1,32.7C1290.2,654.8,1287.3,667.8,1281.9,677.5L1281.9,677.5z M1274.7,634.9 c0,0-1.4-10.7-11.8,1.1c-9,9.9-25.2,28.6-38.3,53.9c13.7-1.5,26.9-9,30.9-12.8C1262,671.3,1277.1,655.7,1274.7,634.9 L1274.7,634.9z M789.2,648.5c-1.9,24.2-11.2,64.9-77.1,85c-43.5,13.1-84.6,6.8-107,1.1c-0.5,8.9-1.5,12.7-2.9,14.2 c-1.9,1.9-16.1,10.1-23.9-1.5c-3.5-5.5-5.3-15.5-6.3-24.4c-50.4-23.2-73.6-56.6-74.5-58.1c-1.1-1.1-12.6-13.1-1.1-27.8 c10.8-13.3,46.1-26.6,77.9-32c1.1-27.2,4.3-47.7,8.1-57.1c4.6-10.9,10.4-1.1,15.4,6.3c4.2,5.5,6.7,29.2,6.9,48.1 c20.8-1,33.1,0.5,56.3,4.7c30.2,5.5,50.4,20.9,48.6,38.4c-1.3,17.2-17.1,24.3-23.1,24.8c-6.3,0.5-16.1-4-16.1-4 c-6.7-3.2-0.5-6,7.6-9.5c8.8-4.3,6.8-8.7,6.8-8.7c-3.3-9.6-42.5-16.3-81.5-16.3c-0.2,21.5,0.9,57.2,1.4,78 c27.3,5.2,47.7,4.2,47.7,4.2s99.6-2.8,102.6-66.4c3.1-63.7-99.3-124.8-175-144.2c-75.6-19.8-118.4-6-122.1-4.1 c-4,2-0.3,2.6-0.3,2.6s4.1,0.6,11.2,3c7.5,2.4,1.7,6.3,1.7,6.3c-12.9,4.1-27.4,1.5-30.2-4.4c-2.8-5.9,1.9-11.2,7.3-18.8 c5.4-8,11.3-7.7,11.3-7.7c93.5-32.4,207.4,26.2,207.4,26.2C773,560.5,791.2,623.9,789.2,648.5L789.2,648.5z M507,645.2 c-10.6,5.2-3.3,12.7-3.3,12.7c19.9,21.4,44.4,34.8,67.7,43.1c2.7-36.9,2.3-49.9,2.6-68.5C537.6,635,516.6,640.8,507,645.2 L507,645.2z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M1479.9,637.6v13.2c0,2.9-2.3,5.2-5.2,5.2h-62.9c0,3.3,0.1,6.2,0.1,8.9c0,19.5-0.8,35.4-2.7,53.3 c-0.3,2.7-2.5,4.7-5.1,4.7h-13.6c-1.4,0-2.7-0.6-3.6-1.6c-0.9-1-1.4-2.4-1.2-3.8c1.9-17.8,2.8-33.5,2.8-52.6 c0-2.8,0-5.7-0.1-8.9h-62.2c-2.9,0-5.2-2.3-5.2-5.2v-13.2c0-2.9,2.3-5.2,5.2-5.2h61.3c-1.3-21.5-3.9-42.2-8.1-63.2 c-0.2-1.3,0.1-2.6,0.9-3.6c0.8-1,2-1.6,3.3-1.6h14.7c2.3,0,4.2,1.6,4.7,3.9c4.1,21.7,6.7,42.8,8,64.5h63.7 C1477.5,632.4,1479.9,634.8,1479.9,637.6z"
}))));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M639.2,463.3c0,0-0.1,0-0.1,0 M638.4,463.4c-0.3,0-0.6-0.1-0.9-0.1C637.8,463.4,638.1,463.4,638.4,463.4 c0.1,0,0.2,0,0.3,0C638.6,463.4,638.5,463.4,638.4,463.4z M638.4,463.4c-0.3,0-0.6-0.1-0.9-0.1 C637.8,463.4,638.1,463.4,638.4,463.4c0.1,0,0.2,0,0.3,0C638.6,463.4,638.5,463.4,638.4,463.4z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M1394.3,532.9c-32.5-79.9-87.4-148-158.8-197c-73.1-50.1-158.8-76.6-247.8-76.6 c-147.2,0-283.8,73.1-365.3,195.6c-0.9,1.3-1.1,3-0.6,4.5c0.5,1.6,1.7,2.7,3.2,3.2l11.4,3.9c0.7,0.2,1.4,0.3,2,0.3 c2.1,0,4.1-1.1,5.3-2.8c37.4-55,88-100.7,146.4-132.3c60.3-32.6,128.6-49.9,197.5-49.9c83.3,0,163.6,24.6,232.4,71 c67.1,45.3,119.2,108.6,150.7,182.9c0.9,2.2,3.1,3.7,5.5,3.7h13.6c1.6,0,3.1-0.8,3.9-2.1C1394.7,536,1394.9,534.4,1394.3,532.9z  M638.4,463.4c-0.3,0-0.6-0.1-0.9-0.2C637.8,463.3,638.1,463.4,638.4,463.4c0.1,0,0.2,0,0.2,0 C638.6,463.4,638.5,463.4,638.4,463.4z M1373.4,537.6c0.3,0.2,0.6,0.4,0.9,0.5C1374,537.9,1373.7,537.8,1373.4,537.6z"
});

var SvgDisneyPlusLogo = function SvgDisneyPlusLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "400 200 1120 680",
    style: {
      enableBackground: "new 0 0 1920 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      display: "inline",
      overflow: "visible"
    },
    width: 1920,
    height: 1080,
    xlinkHref: "BG.png"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, _ref3, _ref4, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _ref5, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 1381.5239,
    cy: 538.896,
    r: 760.1243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.007086212,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03009906,
    style: {
      stopColor: "#CBFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05700687,
    style: {
      stopColor: "#96FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08427694,
    style: {
      stopColor: "#68FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1113,
    style: {
      stopColor: "#43FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1382,
    style: {
      stopColor: "#25FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1647,
    style: {
      stopColor: "#11FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1908,
    style: {
      stopColor: "#04FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2159,
    style: {
      stopColor: "#00FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0000FF",
      stopOpacity: 0
    }
  })), _ref6)))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDisneyPlusLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/disney-plus-logo.1a56f51c.svg";
export { ForwardRef as ReactComponent };